import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = {
    position: { type: String, default: "top" }
  }

  connect() {
    this.boundShow = this.show.bind(this)
    this.boundHide = this.hide.bind(this)

    this.element.addEventListener("mouseenter", this.boundShow)
    this.element.addEventListener("mouseleave", this.boundHide)
    this.element.addEventListener("focus", this.boundShow)
    this.element.addEventListener("blur", this.boundHide)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.boundShow)
    this.element.removeEventListener("mouseleave", this.boundHide)
    this.element.removeEventListener("focus", this.boundShow)
    this.element.removeEventListener("blur", this.boundHide)
  }

  show() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("invisible", "opacity-0")
      this.contentTarget.classList.add("visible", "opacity-100")
    }
  }

  hide() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove("visible", "opacity-100")
      this.contentTarget.classList.add("invisible", "opacity-0")
    }
  }
}
